import { ONBOARDING_STORAGE_KEY } from './storage-key';

/** Remove the persisted onboarding state. */
export const clearOnboardingState = (): void => {
  /* v8 ignore next 3 -- SSR guard: window is always defined under the happy-dom test runner */
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.removeItem(ONBOARDING_STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable (Safari private mode); ignore.
  }
};
